import * as _ from "lodash";

import { ExtensionBase } from "../extensionBase";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions, addDndListener } from "../../viewer";
import * as SmartDrawings from "../../smartDrawings";
import { ColorLegendPanel } from "./colorLegendPanel";
import { UiUtils } from "../../common/uiUtils";
import { TextControl } from "../../controls/textControl";

export class CustomColorExtension extends ExtensionBase {

    static extensionName = "CustomColorExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private colorButton: Autodesk.Viewing.UI.Button;

    private legendPanel: ColorLegendPanel;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);

        this.legendPanel = new ColorLegendPanel(this.viewer, this.viewer.container);
    }

    static registerExtension() {
        super.registerExtension(CustomColorExtension.extensionName, CustomColorExtension);
    }


    onToolbarCreated(): void {
        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.createUi();
    }

    private createUi() {
        if (this.colorButton != null) {
            this.subToolbar.removeControl(this.colorButton);
        }

        this.colorButton = UiUtils.createButton({
            id: "SmartDrawings.ColorButton",
            tooltip: "Model color source",
            iconClass: "ion-md-color-palette",
            onClick: () => this.legendPanel.setVisible(!this.legendPanel.isVisible())
        });

        this.legendPanel.addVisibilityListener(visible => {
            this.colorButton.setState(visible
                ? Autodesk.Viewing.UI.Button.State.ACTIVE
                : Autodesk.Viewing.UI.Button.State.INACTIVE);
        });

        this.subToolbar.addControl(this.colorButton);
    }

   
    load(): boolean {
        console.log("CustomColorExtension is loaded!");
        return super.load();
    };

    isActive(): boolean {
        return this.legendPanel.isVisible();
    }
}